import { LEAD_LIMITS } from "../utils/permissions";

export const MAX_LEAD_COLUMNS = 5;

export const MAX_COLUMN_LABEL_LENGTH = 20;

export const LEAD_FIELD_LIMITS = {
  first_name: { min: 3, max: 30 },
  last_name: { min: 3, max: 150 },
  email: { max: 254 },
  phone: { max: 40 },
  note: { min: 2, max: 500 },
};

export const MAX_NEXT_ACTION_LENGTH = 150;

export interface LeadColumn {
  id: string;
  label: string;
}

export const DEFAULT_COLUMN_IDS = [
  "COL_NEW",
  "COL_CONTACTED",
  "COL_QUALIFIED",
  "COL_WON",
  "COL_LOST",
] as const;

export interface LeadNote {
  at: string;
  text: string;
  edited_at?: string;
}

export interface Lead {
  lead_id: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  column_id: string;
  notes?: LeadNote[];
  next_action?: string;
  next_action_at?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface LeadsSummary {
  lead_count: number;
  lead_limit: number;
}

export const leadLimit = (planTier?: string | null): number =>
  (LEAD_LIMITS as Record<string, number>)[planTier ?? ""] ?? LEAD_LIMITS.free;

export interface CreateLeadInput {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  column_id?: string;
}

export interface UpdateLeadInput {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  column_id?: string;
  next_action?: string;
  next_action_at?: string | null;
  add_note?: string;
  edit_note?: { index: number; text: string };
  delete_note?: { index: number };
}
